import { useRef } from 'react';

import type React from 'react';
import './styles.scss';
import TippyBase from '@tippyjs/react';

const Tippy = TippyBase as React.ComponentType<any>;

type TooltipProps = { children: React.ReactNode; content: React.ReactNode };

export const Tooltip = ({ children, content }: TooltipProps) => {
	const ref = useRef(null);

	return (
		<>
			<span className="tooltip__base" ref={ref}>
				{children}
			</span>
			<Tippy
				content={<div className="tooltip">{content}</div>}
				reference={ref}
				interactive={true}
			/>
		</>
	);
};
